import type { FC } from 'react';

/**
 * Static, non-interactive self-identification marker shown next to the SIP logo.
 * Mirrors the Partner Portal's Konfigurator entry point, which is a link there;
 * in the Konfigurator itself it is a plain label.
 *
 * Bold uppercase text on the dark bar, with no background, rounding or pill
 * padding: the reference design treats it as the tail of the brand lockup, not
 * as a status chip or a call to action. Styling mirrors the Partner Portal's
 * label exactly so the two SIP apps read as one brand. The text stays
 * natural-cased in the DOM and `uppercase` does the casing, which keeps copied
 * text readable. It is `aria-hidden` because the logo link beside it already
 * announces "SIP Konfigurator"; reading the label too would say the app name
 * twice. It stays hidden below `sm` because it is the most droppable element in
 * a row that also carries the cart control and the partner-portal link.
 */
export const ConfiguratorLabel: FC = () => (
  <span
    className="hidden pb-[3px] text-xs leading-none font-bold tracking-wide text-white uppercase sm:block"
    aria-hidden="true"
  >
    Konfigurator
  </span>
);
